import React from "react";
import CopyToClipWithSpan from '../FormParts/CopyToClipWithSpan'
import Convert from '../../common/Convert';

export default class CustomTd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            valid: true,
            label: this.props.label ? this.props.label : 'テキスト',
            name: this.props.name ? this.props.name : '',
        }        
    }

    render() {
        const{label,name,copy, colSpan, data, rootData, error, noBorder=false} = this.props;
        const childrenWithProps = (this.props.value && this.props.value.type && React.Component.prototype.isPrototypeOf((this.props.value.type).prototype))&&React.Children.map(this.props.value, child =>{
            let propsToOverride = {
                ...(name?{"name": name}:{}),
                label: label,
            }
            if (rootData){
                propsToOverride.rootData=rootData
            }
            return React.cloneElement(child, propsToOverride)
        });
        let value = (!this.props.value && (data||(rootData&&rootData.values))) ? Convert.get_view_value(name, data||(rootData&&rootData.values)) : this.props.value

        if(copy){
            value = <CopyToClipWithSpan id={name} label={value} value={value} />
        }
        // const requiredData = rootData&&rootData.requiredData
        return (
            <>
                {label != "" ?
                <td className={`${this.props.tdBackgroundColor ? this.props.tdBackgroundColor : 'subTitle'} ${noBorder ? 'noBorder' : ''}`}>
                    {label}
                {/* {requiredData&&requiredData[Convert.key_split(name).column]?<span style={{color:"red"}}>※</span>:''} */}
                </td>
                :""}
                <td colSpan={colSpan} className={`${noBorder ? 'noBorder' : ''} line-break`}>
                    {childrenWithProps||value}
                    {error && <div style={{color:"red"}}>{error[0]}</div>}
                </td>
            </>
        );
    }
}
